import { FORTA_GRAY3, FORTA_GRAY4, FORTA_WHITE } from '../../../utils/colors';

export const F_OUTLINED_VALUE_FIELD_SX = {
  minHeight: 52,
  px: 1.5,
  py: 0.75,
  display: 'flex',
  alignItems: 'center',
  boxSizing: 'border-box',
  border: `1px solid ${FORTA_GRAY3}`,
  borderRadius: '12px',
  backgroundColor: FORTA_WHITE,
  width: '100%',
};

export const F_OUTLINED_VALUE_CONTENT_SX = {
  width: '100%',
  minWidth: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const F_OUTLINED_VALUE_TEXT_SX = {
  minWidth: 0,
  color: FORTA_GRAY4,
  fontSize: 16,
  fontWeight: 500,
  lineHeight: 1.25,
  overflowWrap: 'anywhere',
};
